import axios from '@/utils/request.js'

// 对私提现申请
export function getrechargelist(params) {
  return axios.get('/finrecharge/rechargelist', {
    params
  })
}
// 对公提现申请
export function getggrechargelist(params) {
  return axios.get('/finrecharge/rechargeglist', {
    params
  })
}
// 日志列表
export function getloglist(params) {
  return axios.get('/finrecharge/loglist', {
    params
  })
}// 调整列表
export function getadjustlist(params) {
  return axios.get('/finrecharge/adjustlist', {
    params
  })
}
//获取用户信息
export function getadjustuserinfo(params) {
  return axios.get('/finrecharge/adjustuserinfo', {
    params
  })
}
//提交调整
export function submitadd(params) {
  return axios.post('/finrecharge/submitadd', {
    params
  })
}
// 图力值订单管理
export function getmoneyorderList(params) {
  return axios.get('/finrecharge/moneyorder', {
    params
  })
}
// 拒绝提现
export function rechargerefuse(params) {
  return axios.post('/finrecharge/rechargerefuse', {
    params
  })
}
//资金回退
export function rechargeback(params) {
  return axios.post('/finrecharge/rechargeback', {
    params
  })
}
//对公打款同意
export function gongrechargerefuse(params) {
  return axios.post('/finrecharge/gongrechargerefuse', {
    params
  })
}
// kmk同意提现
export function rechargeagree(params) {
  return axios.post('/finrecharge/rechargeagree', {
    params
  })
}
// chu同意提现
export function churechargeagree(params) {
  return axios.post('/chupay/rechargeagree', {
    params
  })
}
// 委托详情
export function entrustinfo(params) {
  return axios.get('/finrecharge/entrustinfo', {
    params
  })
}
// 打赏详情
export function rewardinfo(params) {
  return axios.get('/finrecharge/rewardinfoinfo', {
    params
  })
}














